import PageMain from './Main'
import PageGetEmail from './GetEmail'
import PageGetLogin from './GetLogin'
import PageEmailIsTaken from './EmailIsTaken'
import PageLoginSG from './LoginSG'
import PageRegisterSuccess from './PageRegisterSuccess'
import PageRestorePassword from './RestorePassword'
import PageAccountIsTaken from './AccountIsTaken'
import PageNewPassword from './NewPassword'
import PageSgRegister from './SgRegister'
import PageSgActivate from './SgActivate'
import PageIpBlock from './IpBlock'
import PageMfaVerify from './MfaVerify'

export default {
  // «Главная»
  'index': PageMain,
  // Получаем Email, если соц.сеть его не выдала
  'get-email': PageGetEmail,
  // Получаем логин, если соц.сеть его не выдала
  'get-login': PageGetLogin,
  // Выводим ошибку, когда такой email уже есть в базе
  'email-is-taken': PageEmailIsTaken,
  // Выводим ошибку, что этот социальный аккаунт уже привязан к другому пользователю
  'account-is-taken': PageAccountIsTaken,
  // Авторизация по логину и паролю
  'login': PageLoginSG,
  // Восстановление пароля
  'restore-password': PageRestorePassword,
  // Вторая часть восстановления пароля
  'new-password': PageNewPassword,
  // Регистрация через email
  'register': PageSgRegister,
  // Успешно зарегистрировались
  'register-success': PageRegisterSuccess,
  // Активация аккаунта
  'activate': PageSgActivate,
  // Превышена квота регистраций с текущего IP
  'ip-block': PageIpBlock,
  'mfa-verify': PageMfaVerify
}

export const pageIndexes = [
  'index',
  'get-email',
  'get-login',
  'email-is-taken',
  'account-is-taken',
  'login',
  'register',
  'register-success',
  'restore-password',
  'new-password',
  'activate',
  'ip-block',
  'mfa-verify'
];
